import { Injectable, Output, EventEmitter } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { LoadingService } from './loading.service';
import { AuthService } from './auth.service';
import { environment as env } from '../../environments/environment';
import { ToastService } from './toast.service';
const localLog = console.log;

@Injectable({
  providedIn: 'root'
})
export class ScannersService {

  constructor(private http: HttpClient,
    private loadingService: LoadingService,
    private authService: AuthService,
    private toast: ToastService) {

  }

  private _get_headers() {
    return {      withCredentials: true
    };
  }

  async getScanners(): Promise<any> {
    let _id = this.loadingService.add('Loading Scanners');
    try {
      let res: any = await this.http.get(
        `${env.apiUrl}/rest/admin/scanners`,
        this._get_headers(),
      ).toPromise();

      if (res?.err) {
        throw new Error(res.err);
      }

      this.loadingService.remove(_id);
      return res;
    }
    catch (e: any) {
      localLog('Error getScanners() =>', e);
      this.toast.error('Failed to get scanners', e.message);
      this.loadingService.remove(_id);
      return { err: e.message }
    }
  }

  async createScanner(data: any): Promise<any> {
    let _id = this.loadingService.add('Creating scanner');
    try {
      let res: any = await this.http.post(
        `${env.apiUrl}/rest/admin/scanners`,
        data,
        this._get_headers(),
      ).toPromise();

      if (res?.err) {
        throw new Error(res.err);
      }

      this.loadingService.remove(_id);
      return res;
    }
    catch (e: any) {
      localLog('Error createScanner() =>', e);
      this.toast.error('Failed to create scanner', e.message);
      this.loadingService.remove(_id);
      return { err: e.message }
    }
  }

  async updateScanner(scanner_id: string, data: any): Promise<any> {
    let _id = this.loadingService.add('Updating scanner');
    try {
      let res: any = await this.http.put(
        `${env.apiUrl}/rest/admin/scanners/${scanner_id}`,
        data,
        this._get_headers(),
      ).toPromise();

      if (res?.err) {
        throw new Error(res.err);
      }

      this.loadingService.remove(_id);
      return res;
    }
    catch (e: any) {
      console.log('Error updateScanner() =>', e);
      this.toast.error('Failed to update scanner', e.message);
      this.loadingService.remove(_id);
      return { err: e.message }
    }
  }

  // Probe every Scanner.Url server-side and record the HTTP outcome on
  // each row. Long-running (~8s worst case per URL; backend probes in
  // parallel). Returns the summary + per-row results.
  async verifyAllScanners(): Promise<any> {
    let _id = this.loadingService.add('Verifying scanner URLs');
    try {
      let res: any = await this.http.post(
        `${env.apiUrl}/rest/admin/scanners/verify-all`,
        {},
        this._get_headers(),
      ).toPromise();
      if (res?.err) throw new Error(res.err);
      this.loadingService.remove(_id);
      return res;
    }
    catch (e: any) {
      localLog('Error verifyAllScanners() =>', e);
      this.toast.error('Failed to verify scanners', e.message);
      this.loadingService.remove(_id);
      return { err: e.message };
    }
  }

  async deleteScanner(scanner_id: string): Promise<any> {
    let _id = this.loadingService.add('Deleting scanner');
    try {
      let res: any = await this.http.delete(
        `${env.apiUrl}/rest/admin/scanners/${scanner_id}`,
        this._get_headers(),
      ).toPromise();

      if (res?.err) {
        throw new Error(res.err);
      }

      this.loadingService.remove(_id);
      return res;
    }
    catch (e: any) {
      localLog('Error deleteScanner() =>', e);
      this.toast.error('Failed to delete scanner', e.message);
      this.loadingService.remove(_id);
      return { err: e.message }
    }
  }
}
